import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-00",
  "use": "icon-attr-shape-00-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-00\"><circle cx=\"16\" cy=\"16\" r=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol